import { render, staticRenderFns } from "./PolicyDeclaration.vue?vue&type=template&id=080a5587&"
import script from "./PolicyDeclaration.vue?vue&type=script&lang=js&"
export * from "./PolicyDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports